module.exports = __webpack_public_path__ + "img/产品手册-说明书.a9baaeef.svg";